import { useOffers } from "@nju/data-access-portal-offers";
import { ClientProvider } from "@nju/data-access-sales-client";
import { Footer } from "@nju/feature-portal-footer";
import { SelectMsisdnMigrationDatePage } from "@nju/feature-portal-msisdn";
import { ClientOrderInfoBox } from "@nju/feature-sales-client";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { RespectOrchestratorState } from "@nju/feature-sales-orchestrator";
import { Alert, BlockContent, getAlertEsimText, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../../components/ClientSideRenderer";

export default function MigrationSalesDate() {
  const { mobile } = useOffers();
  const offer = mobile.indefiniteOffers.find((offer) => {
    return offer.display;
  });
  const price = offer?.ftthBundleDiscount || offer?.bundleDiscount;

  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <ClientSideOnly>
        <RespectOrchestratorState mode="mobile" state="MNP">
          <ClientProvider>
            <div>
              <ClientOrderInfoBox />
              {(offer?.ftthBundleDiscount || offer?.bundleDiscount) && (
                <Alert iconName="info-circle" text={getAlertEsimText(price)} />
              )}
              <BlockContent>
                <SelectMsisdnMigrationDatePage
                  sourceContractType="PREPAID"
                  variant="sales"
                />
              </BlockContent>
            </div>
          </ClientProvider>
        </RespectOrchestratorState>
      </ClientSideOnly>
      <Footer />
    </LayoutWrapper>
  );
}
